module.exports = __webpack_public_path__ + "img/barcelona.d9bcbb54.jpg";